module.exports = __webpack_public_path__ + "img/form-r-1.628cffa3.svg";